import { axiosPrivate } from "../api/axios";
import axios from "../api/axios";
import { useEffect } from "react";
import useAuth from "./useAuth";

const useAxiosPrivate = () => {
    const { authToken, refreshToken, login } = useAuth();

    useEffect(() => {

        const requestIntercept = axiosPrivate.interceptors.request.use(
            config => {
                if (!config.headers['Authorization']) {
                    config.headers['Authorization'] = `Bearer ${ authToken }`;
                }
                return config;
            }, (error) => Promise.reject(error)
        );

        const responseIntercept = axiosPrivate.interceptors.response.use(
            response => response,
            async (error) => {
                const prevRequest = error?.config;
                if (error?.response?.status === 401 && !prevRequest?.sent) {
                    prevRequest.sent = true;

                    const response = await axios.post('/auth/refresh-token', { refreshToken: refreshToken });
                    const newToken = response.data.token;
                    console.log("Generato nuovo authToken");
                    const newRefreshToken = response.data.refreshToken;
                    login(newToken, newRefreshToken);
                    axiosPrivate.defaults.headers.common['Authorization'] = `Bearer ${newToken}`;

                    prevRequest.headers['Authorization'] = `Bearer ${newToken}`;
                    return axiosPrivate(prevRequest);
                }
                return Promise.reject(error);
            }
        );

        return () => {
            axiosPrivate.interceptors.request.eject(requestIntercept);
            axiosPrivate.interceptors.response.eject(responseIntercept);
        }
    }, [authToken])

    return axiosPrivate;
}

export default useAxiosPrivate;